<template lang="pug">
    .filter-item-wrapper.l-flex-row
        .filter-item
            .filter-label {{ label || property }}
            select.filter-select(
                :value="value"
                @change="handleChange($event.target.value)"
            )
                option(
                    v-if="placeholder"
                    :label="placeholder"
                    :value="null"
                )
                option(
                    v-for="({ key, label }) in options",
                    :value="key"
                    :key="key"
                    :label="label"
                )
</template>

<script>
import WamSelect from '@/components/common/WamSelect/WamSelect'
import { parseFilterParams } from '@/utils/helpers'

export default {
    name: 'SelectFilter',

    components: {
        WamSelect
    },

    props: {
        value: {
            required: false,
            default: null,
            type: [String, Boolean]
        },
        property: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: 'All'
        }
    },

    computed: {
        filterMethod() {
            return item => (this.value !== null ? item[this.property] === this.value : true)
        }
    },

    watch: {
        value: {
            handler(value) {
                this.handleChange(value, true)
            },
            immediate: true
        }
    },

    methods: {
        handleChange(value, force = false) {
            value = parseFilterParams(value)
            if (this.value != value || force) {
                this.$emit('input', value)
                this.$emit('filterChange', this.filterMethod)
            }
        }
    }
}
</script>
